import React, { Component } from 'react'
import NewsSingle from './NewsSingle'

class News extends Component {
  constructor(props) {
    super(props)
    this.state = {
      news: [],
    }
  }

  componentDidMount() {
    const urlStart = 'http://newsapi.org/v2/'
    const urlKey = 'df92ca02d82d4a62be5dc021a4c479b5'
    const url = `${urlStart}${this.props.type}?country=${this.props.country}&category=${this.props.category}&apiKey=${urlKey}`
    console.log(url)
    //?country=gb&category=business
    // FETCH GET METHOD
    fetch(url)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        this.setState({ news: data.articles })
      })
      .catch((error) => console.log(error))
  }

  renderItems = () =>
    this.state.news.map((item) => <NewsSingle key={item.url} item={item} />)

  render() {
    return <div className="row grid-news">{this.renderItems()}</div>
  }
}

export default News
